const NS = 'SupplierListingItemBlock';
const CLS = 'supplierListingItemBlock';

export class SupplierListingItemBlock {
	constructor(element) {

	}

}
